module.exports = __webpack_public_path__ + "img/generico.2cb00bcd.jpg";